import { GET_INDOCUMENTS, GET_INDOCUMENT_ID, POST_INDOCUMENTS } from "../actions/actioninDocument";

const initialState = {
    allInDocuments: [],
    inDocumentDetail: [],
    postInDocuments: {}
}

export default function reducerInDocument(state = initialState, action) {
    switch (action.type) {
        case GET_INDOCUMENTS:
            return{
                ...state,
                allInDocuments: action.payload
            }
        case GET_INDOCUMENT_ID:
            return{
                ...state,
                inDocumentDetail: action.payload
            }
        case POST_INDOCUMENTS:
            return{
                ...state,
                postInDocuments: action.payload
            }
        default:
            return {...state};
    }
}